var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 48,
      height: 48,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.118,60.602c-40.138,17.719-93.777,20.322-143.881-0.447C324.872,50.055,273.523,25.223,255.999,0 c-17.521,25.223-68.871,50.055-93.236,60.154C112.657,80.924,59.021,78.32,18.88,60.602c-7.203-3.182-15.096,2.08-15.096,9.955 C3.784,493.475,255.999,512,255.999,512s252.217-18.525,252.217-441.443C508.216,62.682,500.323,57.42,493.118,60.602z  M456.275,122.963C439.72,416.264,284.815,456.182,255.999,461.07c-28.814-4.889-183.72-44.807-200.273-338.108 c10.978,1.568,22.174,2.367,33.43,2.367c32.033,0,63.305-6.23,92.947-18.518c16.129-6.686,46.719-20.51,73.896-39.258 c27.178,18.748,57.77,32.572,73.898,39.258c29.647,12.289,60.918,18.52,92.949,18.518 C434.103,125.33,445.296,124.529,456.275,122.963z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.304,175.027c3.281,24,7.6,45.598,12.801,64.959h115.92v-104.4c-15.52,8-29.36,14.08-38.561,17.92 C172.505,165.426,142.265,172.707,111.304,175.027z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.025,403.266V271.986h-106.08C164.265,356.625,211.063,390.226,240.025,403.266z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.025,403.266c28.879-13.039,75.68-46.64,106-131.279h-106V403.266z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.025,135.586v104.4h115.84c5.199-19.361,9.52-40.959,12.801-64.959 c-30.961-2.32-61.201-9.602-90.08-21.521C301.304,149.666,287.464,143.586,272.025,135.586z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.38c851fcce1a032eb6c83564a3d6ff5e.svg";
export { ForwardRef as ReactComponent };